export default function NotFoundPage() {
    return (
        <div>
            お探しのページは見つかりませんでした。
        </div>
    );
}
